module.exports = "img/12.fa252e.webp";